export default {"src":"/_next/static/media/footer_email.ac3a3e41.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};